import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {AuthService} from '../../service/auth.service';
import { MatDialog , MatDialogRef , MatDialogConfig } from '@angular/material/dialog';


import { DialogHelpComponent } from './dialog-help/dialog-help.component';


@Component({
  selector: 'navbar',
  templateUrl: 'navbar.component.html',
  styleUrls: ['navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Input() title?: string;
  @Input() openedSidebar = false;
  @Output() sidebarState = new EventEmitter();
  signedInUserName?: string;
  dialogCounter = 1;
  marginRightSignin?: string;
  loadData?: Window;
  constructor(private authService: AuthService, public dialog: MatDialog) {
  }

  open(event:any) {
    this.dialog.closeAll();
    const clickedComponent = event.target.closest('.nav-item');
    const items = clickedComponent.parentElement.children;

    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove('opened');
    }
    clickedComponent.classList.add('opened');
  }

  close(event:any) {
    const clickedComponent = event.target;
    const items = clickedComponent.parentElement.children;

    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove('opened');
    }
  }

  openSidebar() {
    this.openedSidebar = !this.openedSidebar;
    this.sidebarState.emit();
  }

  openDialog() {
    const recipient = 'support@bdatasolutions.onmicrosoft.com'; // Replace with the recipient's email address
    const subject = 'Red Thread Help Request'; // Replace with your subject
    const body = ''; // Replace with your email body

    // Create the mailto link
    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open the mailto link
    window.location.href = mailtoLink;

  //   if(this.dialog.openDialogs.length==0){
  //   this.dialog.open(DialogHelpComponent, { data: { name: data }, disableClose: false });
  // }
}
  ngOnInit() {
    this.marginRightSignin = '0px';
    this.authService.getCurrentUser((err, signedInUser) => {
      this.signedInUserName = signedInUser?.username;
    });
  }
}
